/** Contains the main type for the page like landing news, article error-page */
export function usePageType(pathname = location.pathname) {
  const isNewsPage = pathname.includes('news');
  return isNewsPage ? "news" : "page";
}